import HighlightOffIcon from "@mui/icons-material/HighlightOff";

export default function OneRuleDialTransfButtons(props: any) {

    const {dialRule, setDialRule} = props

    const tmplItems: any = {'replace': '|x|-|', 'remove': '| mm|', 'split': '| x|1|', 'append': '| x |0.265|', 'prepend': '|0| - |', 'multiply': '|1000|', 'numerize': '||', 'strip': '||'}

    const itemStyle: any = {
        color: 'grey',
        fontFamily: "'Inter', sans-serif",
        fontSize: "0.7rem",
        cursor: "pointer",
    }

    const tmplItemsGridStyle: any = {
        display: "flex",
        justifyContent: "space-around",
        marginTop: "3px",
        position: "relative"
    }

    function handleTemplateItemClick (event: any) {
        let clickedItem: any = event.target.innerText
        // console.log(event.target.innerText)
        setDialRule((prev: any) => {
            return {...prev, transformRules: prev.transformRules + clickedItem + tmplItems[clickedItem] + " && "}
        })
    }

    const clearPointStyle: any = {
        position: "absolute",
        top: "-77px",
        right: "5px",
        cursor: "pointer",
    }


    return (
        <>
            <div style={tmplItemsGridStyle}>
                {
                    Object.keys(tmplItems).map((item: any, index: number) => {
                        return (
                            <div key={index} style={itemStyle} onClick={(event) => handleTemplateItemClick(event)}>{item}</div>
                        )
                    })
                }

                {dialRule.transformRules &&
                    <div style={clearPointStyle}>
                        <HighlightOffIcon
                            sx={{fontSize: 14, color: '#e56679'}}
                            onClick={() => setDialRule((prev: any) => {return {...prev, transformRules: ''}})}
                        />
                    </div>
                }

            </div>
        </>

    )

}
